"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.number.constructor");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _scrunchieArrangement = require("@/api/scrunchieArrangement/scrunchieArrangement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      conditionType: {},
      // 条件
      options: [],
      ruleForm: {
        categoryName: '',
        type: 1,
        parentId: null,
        // 上级分类id
        enable: '',
        // 是否启用
        level: 1,
        // 等级
        sort: null,
        // 排序
        id: null
      },
      rules: {
        categoryName: [{
          required: true,
          message: '请输入分类名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 100 个字符',
          trigger: 'blur'
        }],
        enable: [{
          type: 'number',
          required: true,
          message: '请选择状态'
        }],
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }]
      },
      isLevel1: 1
    };
  },
  methods: {
    open: function open(data) {
      this.ruleForm.type = 1;
      this.conditionType = data;
      this.getMaterialCategoryApi();
      /*
      接收data对象：
      type：add、editor（添加，编辑）
      name：名称
      id：id
      */
      if (data.type === 'add') {
        // console.log('添加')
      } else {
        this.getMaterialCategoryByIdApi(data.id);
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {
        categoryName: '',
        type: 1,
        parentId: null,
        // 上级分类id
        enable: '',
        // 是否启用
        level: 1,
        // 等级
        sort: null,
        // 排序
        id: null
      };
      this.isLevel1 = 1;
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.conditionType.type === 'add') {
            _this.saveMaterialCategoryApi();
          } else {
            _this.updateMaterialCategoryApi();
          }
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // radio切换
    onRadioChange: function onRadioChange(val) {
      this.ruleForm.parentId = null;
      this.getMaterialCategoryApi();
    },
    // 查询类目
    getMaterialCategoryApi: function () {
      var _getMaterialCategoryApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                type: this.ruleForm.type,
                level: this.isLevel1
              };
              _context.n = 1;
              return (0, _scrunchieArrangement.getMaterialCategoryApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.options = res.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getMaterialCategoryApi() {
        return _getMaterialCategoryApi2.apply(this, arguments);
      }
      return getMaterialCategoryApi;
    }(),
    // 保存
    saveMaterialCategoryApi: function () {
      var _saveMaterialCategoryApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _scrunchieArrangement.saveMaterialCategoryApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.onClose();
                this.$emit('refresh');
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function saveMaterialCategoryApi() {
        return _saveMaterialCategoryApi2.apply(this, arguments);
      }
      return saveMaterialCategoryApi;
    }(),
    // 查询
    getMaterialCategoryByIdApi: function () {
      var _getMaterialCategoryByIdApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id) {
        var params, res, data, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                id: id
              };
              _context3.n = 1;
              return (0, _scrunchieArrangement.getMaterialCategoryByIdApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                data = res.data;
                this.ruleForm.categoryName = data.categoryName;
                this.ruleForm.type = data.type;
                this.ruleForm.parentId = Number(data.parentId) || null;
                this.ruleForm.enable = data.enable;
                this.ruleForm.level = data.level;
                this.ruleForm.sort = data.sort;
                this.ruleForm.id = data.id;
                this.isLevel1 = Number(data.level - 1);
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getMaterialCategoryByIdApi(_x) {
        return _getMaterialCategoryByIdApi2.apply(this, arguments);
      }
      return getMaterialCategoryByIdApi;
    }(),
    // 修改
    updateMaterialCategoryApi: function () {
      var _updateMaterialCategoryApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context4.n = 1;
              return (0, _scrunchieArrangement.updateMaterialCategoryApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '修改成功'
                });
                this.onClose();
                this.$emit('refresh');
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateMaterialCategoryApi() {
        return _updateMaterialCategoryApi2.apply(this, arguments);
      }
      return updateMaterialCategoryApi;
    }()
  }
};